/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1200 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Amit Singh Rana",
  title: "Hi All, I'm Amit",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Desktop applications with C++ / Qt / C / JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1bTdNHjmZ2oRyqdKLaCK4E7kWhUaZ9zMZ/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/programexecuter",
  linkedin: "https://www.linkedin.com/in/amit-singh-rana/",
  gmail: "amitsingh09011999@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "C/C++ SYSTEMS ENGINEER BUILDING HIGH-PERFORMANCE LINUX APPLICATIONS",
  skills: [
    emoji("⚡ Systems Programming in C/C++ with strong understanding of memory management, OS internals, and Linux kernel fundamentals"),
    emoji("⚡ Multithreaded & Concurrent Programming with synchronization, race-condition handling, and performance-aware design"),
    emoji("⚡ Network & Communication Programming using TCP/UDP Sockets, Serial Communication, and Ethernet-based systems"),
    emoji("⚡ Desktop Application Development using Qt along with strong Data Structures & Algorithms foundation")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "C++",
      fontAwesomeClassname: "devicon-cplusplus-plain",
    },
    {
      skillName: "Qt",
      fontAwesomeClassname: "devicon-qt-original"
    },
    {
      skillName: "C",
      fontAwesomeClassname: "devicon-c-original"
    },
    {
      skillName: "Html-5",
      fontAwesomeClassname: "devicon-html5-plain"
    },
    {
      skillName: "Css3",
      fontAwesomeClassname: "devicon-css3-plain"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "devicon-javascript-plain"
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "devicon-react-original"
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "devicon-nodejs-plain"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "devicon-npm-original-wordmark"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "devicon-azuresqldatabase-plain"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "devicon-mongodb-plain"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "devicon-amazonwebservices-plain-wordmark"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "devicon-python-plain"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "devicon-docker-plain"
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "devicon-linux-plain"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "devicon-git-plain"
    },
    {
      skillName: "Postman",
      fontAwesomeClassname: "devicon-postman-plain"
    },
    {
      skillName: "YAML",
      fontAwesomeClassname: "devicon-yaml-plain"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Guru Jambheshwar University",
      logo: require("./assets/images/gjuLogo.png"),
      subHeader: "Bachelor of Technology in Computer Science",
      duration: "June 2017 - May 2021",
      desc: "",
      descBullets: [
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "C++", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Systems Programming",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Capgemini",
      companylogo: require("./assets/images/capgeminiLogo.png"),
      date: "Dec 2024 - Present",
      desc: "C++ Developer on Ipv6 Protocol",
      descBullets: [
        "Implemented core IPv6 protocols (DHCPv6, SLAAC, DAD, NDP, ICMPv6) in C++ for a Unix-based network testing tool, ensuring reliable protocol behavior and feature functionality.",
        "Developed comprehensive tests using GoogleTest (gtest) for unit testing and Python/Pytest for end-to-end API validation, and authored YAML-based documentation for automated API generation.",
        "Collaborated with cross-functional teams to clarify designs, resolve defects, integrate features, perform bug fixes, conduct PR reviews, and improve overall code quality and consistency."
      ]
    },
    {
      role: "Junior Developer",
      company: "WESEE - Ministry of Defence",
      companylogo: require("./assets/images/weseeLogo.jpeg"),
      date: "May 2023 - Dec 2024",
      desc: "C++ Developer for Data Communication",
      descBullets: [
        "Designed and implemented cross-system communication modules using Qt and C++ for data exchange among components.",
        "Built applications with Serial, TCP, and UDP sockets, using multithreading for low-latency, fault-tolerant interactions, and performed network analysis with Wireshark and Packet Sender.",
        "Developed simulators and automated system tasks using Python and shell scripts for message verification, log parsing, and routine maintenance, improving efficiency and reliability."
      ]
    },
    {
      role: "Assistant Systems Engineer",
      company: "Tata Consultancy Services",
      companylogo: require("./assets/images/tcsLogo.webp"),
      date: "Sep 2021 - Dec 2022",
      desc: "Linux System Admin & C++ Programmer",
      descBullets: [
        "Developed and maintained Linux-based system utilities in C++ and shell scripting, improving automation and maintenance.",
        "Built Qt-based internal tools and lightweight TCP/UDP/file-processing utilities for log viewing, config change, monitoring, etc.",
        "Enhanced system reliability with automation scripts (Bash/Python) for service monitoring, log rotation, and periodic tasks."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects 
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/capgeminiLogo.png"),
      projectName: "",
      projectDesc: "",
      footerLink: [
        {
          name: "",
          url: ""
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "",
      subtitle:
        ".",
      image: require("./assets/images/capgeminiLogo.png"),
      imageAlt: "",
      footerLink: [
        {
          name: "",
          url: ""
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "",
      title: "",
      description: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-8860817080",
  email_address: "amitsingh09011999@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
